let elementscroll = {
    scrollHorizontally: (id, right, size) => {
        var element = document.getElementById(id);
        if (element) {
            var container = element.parentNode;
            if (right) {
                element.scrollLeft += size;
            } else {
                element.scrollLeft -= size;
            }
            if (element.scrollLeft > 0) {
                container.classList.remove("hide-left-nav");
            } else if (element.scrollLeft == 0) {
                container.classList.add("hide-left-nav");
            }
            if (element.scrollLeft == (element.scrollWidth - element.clientWidth)) {
                container.classList.add("hide-right-nav");
            } else if (element.scrollLeft < (element.scrollWidth - element.clientWidth)) {
                container.classList.remove("hide-right-nav");
            }
            element.addEventListener('scroll', function (e) {
                if (element.scrollLeft > 0) {
                    container.classList.remove("hide-left-nav");
                } else if (element.scrollLeft == 0) {
                    container.classList.add("hide-left-nav");
                }
                if (element.scrollLeft == (element.scrollWidth - element.clientWidth)) {
                    container.classList.add("hide-right-nav");
                } else if (element.scrollLeft < (element.scrollWidth - element.clientWidth)) {
                    container.classList.remove("hide-right-nav");
                }
            });
        }
    },
    scrollingEvent: (elementId, containerId) => {
        var element = document.getElementById(elementId);
        var container = document.getElementById(containerId);

        element.addEventListener('scroll', function (e) {
            if (!stickymenu.ticking) {
                window.requestAnimationFrame(function () {
                    if (element.scrollLeft > 0) {
                        container.classList.remove("hide-left-nav");
                    } else if (element.scrollLeft == 0) {
                        container.classList.add("hide-left-nav");
                    }
                    if (element.scrollLeft == (element.scrollWidth - element.clientWidth)) {
                        container.classList.add("hide-right-nav");
                    } else if (element.scrollLeft < (element.scrollWidth - element.clientWidth)) {
                        container.classList.remove("hide-right-nav");
                    }
                    stickymenu.ticking = false;
                });
                stickymenu.ticking = true;
            }

        });
    },
    scrollToElement: (parentId, element, horizontal) => {
        const parentElement = document.getElementById(parentId);
        if (parentElement) {
            var el = parentElement.getElementsByClassName(element)[0];
            if (el) {
                if (horizontal) {
                    parentElement.scrollLeft = el.offsetLeft - (window.innerWidth / 2);
                }
                else {
                    parentElement.scrollTop = el.offsetTop;
                }
            }
        }
    },
    scrollHorizontalToElement: (parentId, element) => {
        const parentElement = document.getElementById(parentId);
        if (parentElement) {
            var el = parentElement.getElementsByClassName(element)[0];
            var left = parentElement.scrollLeft;

            parentElement.scrollLeft = el.offsetLeft - 100;
            elementscroll.setNavArrows(parentElement);
        }
    },
    setNavArrows: (element) => {
        var container = element.parentNode;
        if (container) {

            if (element.scrollLeft > 0) {
                container.classList.remove("hide-left-nav");
            } else if (element.scrollLeft == 0) {
                container.classList.add("hide-left-nav");
            }
            if (element.scrollLeft == (element.scrollWidth - element.clientWidth)) {
                container.classList.add("hide-right-nav");
            } else if (element.scrollLeft < (element.scrollWidth - element.clientWidth)) {
                container.classList.remove("hide-right-nav");
            }
        }
    },

    windowScroll: (parentId) => {

        setTimeout(() => {
            const parentElement = document.getElementById(parentId);

            if (parentElement) {

                var top = parentElement.offsetTop;

                var headerHeight = 120;
                if (window.innerWidth < 1199) {
                    headerHeight = 73;
                    parentElement.classList.add("extrapadding");
                }

                var importantNotice = document.querySelector('.important-notice__visible');
                if (importantNotice !== null) {
                    headerHeight += importantNotice.offsetHeight;
                }

                window.scroll({
                    top: top - headerHeight,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }, 500)


    },
    scrollToTop: () => {
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }, 100);
    },
    overIdScroll: (parentId, top, checkScroll = false) => {
        const parentElement = document.getElementById(parentId);
        if (!parentElement) return;
        const rect = parentElement.getBoundingClientRect();
     
        if (checkScroll) {

            const windowHeight = window.innerHeight;
            if (rect.bottom < windowHeight - top) return;
        }

        window.scroll({
            top: rect.top + window.scrollY - top,
            left: 0,
            behavior: 'smooth'
        });

    },
    focusElement: function (elementId) {
        const element = document.getElementById(elementId);
        if (element) {
            setTimeout(() => {
                element.focus();
            }, 200);
        }
    }
};

export { elementscroll };